import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BoldParagraph,
  Icon,
  StyledCardFilterBy,
} from '../../../styledComponents';
import { CourseOptionDisplayModuleContext } from '../../../context';
import { CourseOptionFilterType } from '../../../constants';
import { OptionDisplayFilterItem } from '../OptionDisplayFilterItem';

export function OptionDisplayFilter() {
  const { t } = useTranslation();
  const { filters } = useContext(CourseOptionDisplayModuleContext);

  const deliveryTypeFilter = filters[CourseOptionFilterType.DELIVERY_TYPE];
  const languageFilter = filters[CourseOptionFilterType.LANGUAGE];
  const currencyFilter = filters[CourseOptionFilterType.CURRENCY];

  return (
    <>
      <StyledCardFilterBy>
        <Icon matIcon="tune" outlined />
        <BoldParagraph
          text={t(
            'site.modules.course-option-display.card.filter.section.title',
          )}
        />
      </StyledCardFilterBy>
      {deliveryTypeFilter.shown && (
        <OptionDisplayFilterItem
          label={t(
            'site.modules.course-option-display.card.filter.delivery-type.label',
          )}
          filterKey={CourseOptionFilterType.DELIVERY_TYPE}
          options={deliveryTypeFilter.options}
        />
      )}
      {languageFilter.shown && (
        <OptionDisplayFilterItem
          label={t(
            'site.modules.course-option-display.card.filter.language.label',
          )}
          filterKey={CourseOptionFilterType.LANGUAGE}
          options={languageFilter.options}
        />
      )}
      {currencyFilter.shown && (
        <OptionDisplayFilterItem
          label={t(
            'site.modules.course-option-display.card.filter.currency.label',
          )}
          filterKey={CourseOptionFilterType.CURRENCY}
          options={currencyFilter.options}
        />
      )}
    </>
  );
}
